import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Modal, ModalFooter, ModalHeader, Col, CardTitle } from "reactstrap"
import TeamAccordian from "./accordion"
import { workReport } from "store/trackprofile/action"
import { setismodal } from "store/actions"
import { isEmpty } from "lodash"
import moment from "moment"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

// Strips HTML/entities/whitespace so an "empty" CKEditor value (e.g. "<p>&nbsp;</p>") is detected as empty.
const stripReport = html =>
  (html || "")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim()

// A slot has tracked hours when its taskTotalHours (e.g. "00:30:00") contains a non-zero digit.
const hasTrackedHours = t => String(t || "").replace(/[^1-9]/g, "") !== ""

const VerifyTeamModal = props => {
  const {
    isOpen,
    toggle,
    rowlistData,
    handleApprove,
    handleReject,
    sethandleAccordion,
    handleAccordion,
    handlecancel,
    myhours,
    handleApproveAll,
    handleRejectAll,
    setisReportModal,
    HoursReportPage,
  } = props

  const [TeamWorkReportState, setTeamWorkReportState] = useState([])
  const [reportValues, setReportValues] = useState({})
  const evaluationHoursForTeams = useSelector(
    state => state?.teams?.evaluationHoursSuccess
  )

  const dispatch = useDispatch()
  const { TeamWorkReport } = useSelector(state => ({
    TeamWorkReport: state?.teams?.teamsWorkreport,
  }))
  useEffect(() => {
    if (TeamWorkReport?.projectSummaryList[0]?.tasks) {
      const tasks = TeamWorkReport?.projectSummaryList[0]?.tasks.map((task, index) => ({
        ...task,
        uniqueKey: `${task.workReportId}_${task.taskName}_${index}_${Date.now()}`
      }))
      setTeamWorkReportState(tasks)
    }
  }, [TeamWorkReport])
  const handleChangeReportValue = (uniqueKey, value) => {
    const tempTeamWorkReportState = TeamWorkReportState?.map((el, idx) => {
      if (uniqueKey === el.uniqueKey) {
        return { ...el, reportDetail: value }
      } else {
        return el
      }
    })
    setTeamWorkReportState(tempTeamWorkReportState)

    // Update the reportValues state for the specific editor
    setReportValues(prev => ({
      ...prev,
      [uniqueKey]: value
    }))
  }

  // save report by users
  const saveReport = () => {
    // Parity with the desktop app: a work report is mandatory for EVERY tracked time slot.
    // Block submission until each editable slot with tracked hours has a non-empty report.
    // Already-emailed slots are read-only, so they are excluded from the requirement.
    const firstEmpty = TeamWorkReportState.find(el => {
      const isEmailed = el?.screenVerifiedStatus === "Emailed to Client "
      if (isEmailed || !hasTrackedHours(el?.taskTotalHours)) return false
      return stripReport(el?.reportDetail).length === 0
    })
    if (firstEmpty) {
      // Expand the first offending slot so the user sees exactly which one to fill.
      sethandleAccordion(firstEmpty.uniqueKey)
      toastr.warning(
        "A work report is required for every tracked time slot. Please fill the highlighted slot before submitting.",
        "Work report required"
      )
      return
    }

    const taskreport = TeamWorkReportState.map(el => ({
      id: el?.workReportId,
      accountid: TeamWorkReport?.projectSummaryList[0]?.accountID,
      date: TeamWorkReport?.date,
      taskname: el?.taskName,
      reportdetail: el.reportDetail,
      totalhours: el?.taskTotalHours,
      formattedreportdetail: el.reportDetail,
    }))
    dispatch(workReport({ workReport: taskreport }, handleResponse))
  }

  const handleResponse = status => {
    if (status === "SUCCESS") {
      dispatch(setismodal(false))
      setisReportModal && setisReportModal(false)
    }
  }

  useEffect(() => {
    if (!isEmpty(TeamWorkReportState) && handleAccordion === null)
      sethandleAccordion(TeamWorkReportState[0]?.uniqueKey)
  }, [TeamWorkReportState])

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal modal-xl"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={handlecancel}>
          <div className="d-flex">
            <div>View Report</div>
            {TeamWorkReport?.projectSummaryList[0]?.totalHoursWorked && (
              <div className="totalhrs mr-1">
                {`Total Hours :   ${TeamWorkReport?.projectSummaryList[0]?.totalHoursWorked}`}
              </div>
            )}
          </div>
        </ModalHeader>
        {TeamWorkReportState?.map((item, idx) => {
          return (
            <TeamAccordian
              key={item.uniqueKey}
              item={item}
              sethandleAccordion={sethandleAccordion}
              handleAccordion={handleAccordion}
              keyId={item.uniqueKey}
              handleChangeReportValue={handleChangeReportValue}
              reportValue={reportValues[item.uniqueKey] || item.reportDetail}
            />
          )
        })}
        {!HoursReportPage && (
          <>
            {!myhours && !isEmpty(evaluationHoursForTeams) && (
              <div className="p-3">
                <CardTitle>Evaluations</CardTitle>
                {!isEmpty(evaluationHoursForTeams) &&
                  (evaluationHoursForTeams || []).map((item, index) => {
                    return (
                      <div className="pt-3" key={index}>
                        <cardText className="me-2">
                          StartTime : &nbsp;
                          <b>{moment(item?.starttime).format("HH:mm:ss")}</b>
                        </cardText>
                        <cardText className="me-2">
                          EndTime : &nbsp;
                          <b>{moment(item?.endtime).format("HH:mm:ss")}</b>
                        </cardText>
                        <br />
                        <cardText className="me-2">
                          Comments : &nbsp;<b> {item?.comments}</b>{" "}
                        </cardText>
                        <div className="d-flex justify-end pt-2">
                          <button
                            type="button"
                            className="btn btn-primary save-user me-2 align_width-child"
                            onClick={() =>
                              handleApprove(
                                item,
                                (evaluationHoursForTeams || [])?.length === 1
                              )
                            }
                          >
                            Accept
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger align_width-team"
                            onClick={() =>
                              handleReject(
                                item,
                                (evaluationHoursForTeams || [])?.length === 1
                              )
                            }
                          >
                            Reject
                          </button>
                        </div>
                      </div>
                    )
                  })}
              </div>
            )}
          </>
        )}
        <ModalFooter className="mobile_align_approve">
          {!myhours && !isEmpty(evaluationHoursForTeams) && (
            <Col>
              <div className="text-START p-0">
                <button
                  type="submit"
                  className="btn btn-primary save-user me-2 align_width-child"
                  onClick={() => handleApproveAll()}
                >
                  Approve All
                </button>
                <button
                  type="button"
                  color="primary"
                  className="btn btn-danger align_width-team"
                  onClick={() => handleRejectAll()}
                >
                  Reject All
                </button>
              </div>
            </Col>
          )}
          <Col>
            <div className="text-end p-0">
              {!HoursReportPage && (
                <button
                  type="submit"
                  className="btn btn-primary save-user me-2 align_width-child"
                  onClick={saveReport}
                >
                  Save
                </button>
              )}
              <button
                type="button"
                color="primary"
                className="btn btn-secondary align_width-team"
                onClick={handlecancel}
              >
                Cancel
              </button>
            </div>
          </Col>
        </ModalFooter>
      </div>
    </Modal>
  )
}

VerifyTeamModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default VerifyTeamModal
